import React, { useMemo } from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { ClientReportRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';


export type ClientReportTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportTableProps) => {
  const headers = [
    'Period',
    'Date Sent',
    'Approved By',
    'Deliveries',
    'Inspections',
    'Milestones'
  ];
  const params = useParams();
  const { data } = ds.useQuery({
    filter: {
      projectId: params.projectId ?? ''
    }
  });

  const rows = useMemo(() => {
    return data.map((node, i) => (
      <ClientReportRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);
  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />
  );
};
